import Vue from 'vue'

export const bggService = {
  search,
  get
}

function search (search) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/boardgamegeek/search'), { 'search': search })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function get (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/boardgamegeek/details'), { 'id': id })
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/bgg.service.js